export { default as NotesEditorViewState } from './schema/NotesEditorViewState';
import { createLazyComponent, LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "CalendarNotesEditor", webpackPrefetch: true */ './lazyIndex')
);

export const NotesEditor = createLazyComponent(lazyModule, m => m.NotesEditor);
export let lazyOpenNotesEditor = new LazyAction(lazyModule, m => m.openNotesEditor);

export { default as closeNotesEditor } from './actions/closeNotesEditor';
export { default as getNotesEditorViewState } from './selectors/getNotesEditorViewState';
export { default as onNotifyOrganizerToggled } from './actions/onNotifyOrganizerToggled';
export { forwardEvent } from './actions/forwardEvent';
